import { Field, useForm } from 'react-final-form';
import { isFunction } from 'lodash';
import { ButtonProps } from '@lendi-ui/button';
import getColour from '@lendi-ui/commons/colours';
import Check from '@lendi-ui/icon/Check';
import ChevronRight from '@lendi-ui/icon/ChevronRight';

import { FIELD_VALUES } from '@funnels/constants';

import { Action } from './index.style';

type ActionValue = FIELD_VALUES | boolean;

interface ArrowActionProps extends ButtonProps {
  isSelected?: boolean;
  name: string;
  value: ActionValue;
  onClick?: (e: React.SyntheticEvent<Element, Event>) => void;
}

interface SecondaryActionProps extends ButtonProps {
  isSelected?: boolean;
}

const Arrow = <ChevronRight color={getColour('interaction', 'contrast')} height="32px" width="32px" />;

const CheckIcon = <Check color={getColour('interaction', 'contrast')} height="32px" width="32px" />;

const ArrowAction = (props: ArrowActionProps) => {
  const { isSelected, onClick, className, ...rest } = props;
  const form = useForm();

  const handleClick = (e: React.SyntheticEvent<Element, Event>) => {
    if (isFunction(onClick)) {
      onClick(e);
    }

    form.change(props.name, props.value);
  };

  return (
    <Field name={props.name}>
      {() => (
        <Action
          {...rest}
          after={Arrow}
          before={isSelected ? CheckIcon : null}
          data-component={props.children}
          type={'submit'}
          onClick={handleClick}
          className={className}
        />
      )}
    </Field>
  );
};

const SecondaryAction = (props: ArrowActionProps) => {
  const { isSelected, onClick, className, ...rest } = props;
  const form = useForm();

  const handleClick = (e: React.SyntheticEvent<Element, Event>) => {
    if (isFunction(onClick)) {
      onClick(e);
    }

    form.change(props.name, props.value);
  };

  return (
    <Field name={props.name}>
      {() => (
        <Action
          {...rest}
          size="lg"
          variant={isSelected ? 'primary' : 'secondary'}
          data-component={props.children}
          type={'submit'}
          onClick={handleClick}
          customized={true}
          className={className}
        />
      )}
    </Field>
  );
};

const VanillaArrowAction = (props: ButtonProps) => {
  return (
    <Action data-component={props.children} className={props.className} {...props} after={Arrow} type={'submit'} />
  );
};

const VanillaSecondaryAction = (props: SecondaryActionProps) => {
  const { isSelected, ...rest } = props;

  return (
    <Action
      {...rest}
      data-component={props.children}
      size="lg"
      variant={isSelected ? 'primary' : 'secondary'}
      type={'submit'}
      customized
    />
  );
};

export { Action, ArrowAction, VanillaArrowAction, SecondaryAction, VanillaSecondaryAction };
